import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { SwitcherWithLabel } from 'src/components/FormComponents/SwitcherWithLabel/SwitcherWithLabel';
import { BetReferralSwitcherLabelWrapper } from './BetReferralFeature.style';
import { useAppStateContext } from 'src/AppState/AppState';

export const BetReferralFeature = observer('BetReferralFeature', () => {
    const common = useCommon();
    const { betBuilderReferralSwitchShow } = ConfigState.get(common).config;
    const {
        bettingConfigsState: {
            isBetReferralEnabled,
            isBetBuilderReferralEnabled,
            handleSetBetReferral,
            handleSetBetBuilderReferral,
        },
    } = useAppStateContext();

    return (
        <BetReferralSwitcherLabelWrapper>
            <SwitcherWithLabel
                label='Bet Referral Feature'
                isSwitched={isBetReferralEnabled}
                onChangeAction={handleSetBetReferral}
            />
            {betBuilderReferralSwitchShow ? (
                <SwitcherWithLabel
                    label='Bet Builder Referral Feature'
                    isSwitched={isBetBuilderReferralEnabled}
                    onChangeAction={handleSetBetBuilderReferral}
                />
            ) : null}
        </BetReferralSwitcherLabelWrapper>
    );
});
